/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react'

export default function BNBMonoIcon(props) {
  return (
    <svg
      width={props?.size || '25'}
      height={props?.size || '25'}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M250 10C382.548 10 490 117.452 490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10Z"
        fill="#00CACD"
        fillOpacity="0.1"
        stroke="#00CACD"
        strokeWidth="20"
      />
      <g clipPath="url(#clip0_1421_3052)">
        <g filter="url(#filter0_d_1421_3052)">
          <path
            d="M249.841 80L354.018 183.934L315.517 222.436L249.841 156.699L184.165 222.777L145.665 184.274L249.841 80ZM118.478 211.475L156.628 250L118.501 288.185L80 250L118.478 211.475ZM249.841 211.497L288.319 249.66L249.83 288.185L211.34 250L249.83 211.497H249.841ZM381.193 211.475L420 250L381.533 288.525L343.044 250L381.193 211.475ZM315.506 277.223L354.007 315.726L249.83 420L145.653 315.749L184.154 277.223L249.83 343.301L315.506 277.223Z"
            fill="#00CACD"
          />
          <path
            d="M353.3 315.726L249.829 419.292L146.359 315.749L184.153 277.931L249.476 343.653L249.83 344.01L250.185 343.653L315.506 277.931L353.3 315.726ZM419.291 250.001L381.532 287.817L343.749 249.998L381.195 212.181L419.291 250.001ZM155.922 249.998L118.499 287.479L80.708 249.997L118.477 212.184L155.922 249.998ZM287.611 249.661L249.828 287.479L212.048 249.998L249.837 212.197L287.611 249.661ZM353.31 183.934L315.518 221.729L250.195 156.346L249.841 155.991L249.486 156.347L184.164 222.068L146.371 184.273L249.842 80.7061L353.31 183.934Z"
            stroke="#00CACD"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1421_3052"
          x="76"
          y="80"
          width="348"
          height="348"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1421_3052" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1421_3052" result="shape" />
        </filter>
        <clipPath id="clip0_1421_3052">
          <rect width="340" height="340" fill="white" transform="translate(80 80)" />
        </clipPath>
      </defs>
    </svg>
  )
}
